import { Link, useLocation } from 'react-router-dom';
import { menuSections, matchesPrefix } from '../navConfig';

/**
 * Landing page for a menu section (e.g. /products, /invoices).
 *
 * The cards are generated from navConfig — the same list the sidebar renders —
 * so the two cannot drift apart. They previously were hand-written copies and
 * had: links the menu no longer offered (Add Product/Category/Manufacturer,
 * now drawers), links the menu never had (/orders/*), a stale path
 * (/invoices/add vs /invoices/create), a missing entry (Импорт), and English
 * labels in an otherwise Macedonian UI.
 *
 * Add a section entry in navConfig and this page picks it up automatically.
 */
export default function SectionLanding({ sectionName }) {
  const location = useLocation();

  const section = sectionName
    ? menuSections.find((s) => s.name === sectionName)
    : menuSections.find((s) => matchesPrefix(location.pathname, s.prefix));

  const children = section?.children ?? [];

  if (!children.length) return null;

  return (
    <div className="bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">{section.name}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {children.map(({ name, href, icon, description }) => (
            <Link
              key={href}
              to={href}
              className="flex items-start gap-3 p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md hover:border-blue-300 transition"
            >
              <span className="mt-0.5 text-blue-600 shrink-0">{icon}</span>
              <span>
                <span className="block font-semibold text-gray-900">{name}</span>
                {description && (
                  <span className="block text-sm text-gray-500 mt-0.5">{description}</span>
                )}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
